import autoload from "./autoload";
import auth from "./mixins/auth";
import cart from "./mixins/cart";
import initDom from "./mixins/init_dom";
import vToken2 from "./components/global/Token2.vue";
import SpecificationTable from "./components/shop/product_detail/SpecificationTable";
import countries from "./mixins/countries";
import ProductMessages from "./components/ProductMessages.vue";
import LaserOptimizedIcon from "./components/icons/laserOptimizedIcon.vue"
import { flexible } from "@nic-industries/hooks";

autoload();

window.app = new Vue({
  el: "#vue-shop-details",
  mixins: [initDom, auth, cart, countries],
  components: { vToken2, SpecificationTable, ProductMessages, LaserOptimizedIcon },

  data() {
    return {
      product: window._PR?.product || {},
      creations: window._PR?.creations || [],
      kitRule: window._PR?.kitRule || {},
      type: window._PR?.type || "",
      initialPrice: window._PR?.initialPrice || "",
      initialPricePerUnit: window._PR?.initialPricePerUnit || "",
      baseUnit: window._PR?.baseUnit || "",
      question: {
        payload: {
          body: "",
          group: "qa",
        },
        response: {
          type: "",
          message: "",
        },
      },
      notifications: [],
      quantity: window._PR?.product?.pricing[0]?.starting_quantity.value || 1,
      additionalImages: window._PR?.additionalImages || [],
      variants: Array.from(window._PR?.variants) || [],
      variantFound: window._PR?.variantFound || false,
      messages: window._PR?.messages || [],
      faqArticles: window._PR?.faqArticles || [],
      relatedArticles: window._PR?.relatedArticles || [],
      shipByShort: "",
      searchText: "",
      showFullDesc: false,
      isOnWishlist: false,
      askQuestion: false,
      selectedPicklistProduct: "",
      selectedProducts: [],
      appendedProduct: {},
      appendedProduct_extra: {},
      productCount: 0,
      productCount_extra: 0,
      variantTotalPrice: "",
      selectedVariant: window._PR?.selectedVariant || {},
      selectedVariantUnit: "",
      stockNotification: {
        email: "",
        sku: "",
        quantity: 1,
      },
      submittingStockNotificationEmail: false,
      stockNotificationSuccessful: false,
      stockNotificationFailed: false,
      stockNotificationErrorMessage:
        "An error occurred when trying to submit your email. Please verify your email or refresh the page and try again.",
      accountInfoFailed: false,
      hasCompany: false,
      phoneNumber: "",
      primaryEmail: "",
      companyName: "",
      signUpCountry: "",
      countries: [],
      loading: false,
      productSearchOptions: {
        placeholder: "Type name or SKU here...",
        multiple: false,
        ajax: {
          url: "/api/proxify/domains/cerakote/shop/products",
          delay: 150,
          cache: false,
          data(params) {
            return {
              q: params.term,
              anycat: window._PR?.kitRule[0].shop_category
                ? window._PR?.kitRule[0].shop_category.child_or_categories.length
                  ? window._PR?.kitRule[0].shop_category.child_or_categories
                      .map((entity) => entity["code"])
                      .join(",")
                  : window._PR?.kitRule[0].shop_category.code
                : "",
              allcats:
                window._PR?.kitRule[0].shop_category &&
                window._PR?.kitRule[0].shop_category.child_and_categories.length
                  ? window._PR?.kitRule[0].shop_category.child_and_categories
                      .map((entity) => entity["code"])
                      .join(",")
                  : "",
              show_variants: true,
            };
          },
          processResults(data, params) {
            return { results: data.data };
          },
        },
        templateResult(item) {
          if (item.loading) {
            return item.text;
          }
          item.text = `${item.name}`;
          return `${item.name}-${item.sku}`;
        },
        templateSelection(item) {
          return item.text;
        },
      },

      //TODO @productSearchOptions_extra isn't ideal. This should take in a key to determine which data array it needs to query.

      productSearchOptions_extra: {
        placeholder: "Type name or SKU here...",
        multiple: false,
        ajax: {
          url: "/api/proxify/domains/cerakote/shop/products",
          delay: 150,
          cache: false,
          data(params) {
            return {
              q: params.term,
              anycat: window._PR?.kitRule[1].shop_category
                ? window._PR?.kitRule[1].shop_category.child_or_categories.length
                  ? window._PR?.kitRule[1].shop_category.child_or_categories
                      .map((entity) => entity["code"])
                      .join(",")
                  : window._PR?.kitRule[1].shop_category.code
                : "",
              allcats:
                window._PR?.kitRule[1].shop_category &&
                window._PR?.kitRule[1].shop_category.child_and_categories.length
                  ? window._PR?.kitRule[1].shop_category.child_and_categories
                      .map((entity) => entity["code"])
                      .join(",")
                  : "",
              show_variants: true,
            };
          },
          processResults(data, params) {
            return { results: data.data };
          },
        },
        templateResult(item) {
          if (item.loading) {
            return item.text;
          }
          item.text = `${item.name}`;
          return `${item.name}-${item.sku}`;
        },
        templateSelection(item) {
          return item.text;
        },
      },
    };
  },

  mounted() {
    let vm = this;

    vm.getCountries();
    vm.stockNotification.sku = vm.product.sku;

    vm.$on("userLogged", (profileData) => {
      vm.getWishlist();
      vm.stockNotification.email = vm.me.primary_email;
    });

    if (vm.variants.length) {

      vm.selectedVariant = vm.product.variants[0];
      vm.calculateVariantTotalPrice();

      let shirt = false;
      let lastEnabledVariant = {};

      vm.variants.map((variant) => {
        let variantPrice = parseFloat(
          variant.pricing[0].price_per_base_quantity.amount
        );
        let selectedPrice = parseFloat(
          vm.selectedVariant.pricing[0].price_per_base_quantity.amount
        );

        if (variant.enabled) {
          lastEnabledVariant = variant;
        }

        if (variant.option_label === "L") {
          if (variant.enabled) {
            vm.selectedVariant = lastEnabledVariant;
          } else {
            vm.selectedVariant = variant;
          }

          shirt = true;
        } else if (!shirt && variantPrice < selectedPrice) {
          vm.selectedVariant = variant;
        }
      });
    }
  },

  watch: {

    quantity: {
      handler() {
        const baseQuantity = this.product.pricing[0].starting_quantity.value || 1;
        if (!this.quantity || this.quantity < 1) {
          this.quantity = baseQuantity;
        }
        this.changePrice();
      }
    },

    isLoggedIn(loggedIn) {
      if (loggedIn) {
        this.stockNotification.email = this.me.primary_email;
        this.getWishlist();
      }
    },

    selectedVariant: {
      deep: true,
      handler() {
        this.calculateVariantTotalPrice();
      },
    },

  },

  computed: {

    selectedVariantPrice() {
      if (!this.selectedVariant) {
        return ''
      }

      return this.selectedVariant.pricing
        ? this.selectedVariant.pricing[0].price_per_base_quantity.amount
        : this.product.pricing[0]?.price_per_base_quantity.amount;
    },
    selectedVariantStock() {
      return this.selectedVariant
        ? this.selectedVariant.stock_level
        : this.product.stock_level;
    },
    maxKitRuleProducts() {
      return this.product.kit_items.filter((item) => item.type === "rule")
        .amount;
    },
    hasPicklist() {
      return this.product.kit_items.some((item) => item.type === "picklist");
    },
    validProduct() {
      if (this.product.kit_items) {
        if (this.hasPicklist && !this.selectedPicklistProduct) return false;

        if (
          !_.isEmpty(this.kitRule[0]) &&
          this.kitRule[0].amount !== this.productCount
        )
          return false;

        if (
          !_.isEmpty(this.kitRule[1]) &&
          this.kitRule[1].amount !== this.productCount_extra
        )
          return false;

        return true;
      }

      return true;
    },
    hasEnteredEmailAddress() {
      if (this.stockNotification.email) {
        let emailRegex = /\S+@\S+\.\S+/g;
        return emailRegex.test(this.stockNotification.email);
      }

      return false;
    },
    mePrimaryPhone() {
      return this.$root.me.primary_phone;
    },
    mePrimaryEmail() {
      return this.$root.me.primary_email;
    },
    meCompanyName() {
      return this.$root.me.company_name;
    },
    meCustomerID() {
      return this.$root.me.customer_id;
    },
    showRequiredAccountValidation() {
      return (
        !this.$root.me.primary_phone ||
        !this.$root.me.primary_email ||
        !this.$root.me.company_name ||
        !this.$root.me.customer_id
      );
    },
    hasRequiredAccountInformation() {
      let requiredFields = [];

      // Does their account have a primary phone number?
      if (!this.mePrimaryPhone) {
        requiredFields.push(this.hasEnteredPhoneNumber);
      }

      // Does their account have a primary email (Possible
      // with Facebook login)?
      if (!this.mePrimaryEmail) {
        requiredFields.push(this.hasEnteredPrimaryEmailAddress);
      }

      // Does their account have a company name?
      if (!this.meCompanyName) {
        requiredFields.push(this.hasValidCompany);
      }

      if (
        !this.$root.me.customer_id &&
        (this.selectedDistributor || this.forceDistributor)
      ) {
        requiredFields.push(this.hasSelectedCountry);
      }

      return requiredFields.every((requiredField) => requiredField === true);
    },
    hasEnteredPrimaryEmailAddress() {
      if (this.primaryEmail) {
        let emailRegex = /\S+@\S+\.\S+/g;
        return emailRegex.test(this.primaryEmail);
      }

      return false;
    },
    hasEnteredPhoneNumber() {
      return this.phoneNumber.length > 7;
    },
    hasValidCompany() {
      return !this.hasCompany || this.hasEnteredCompany;
    },
    hasEnteredCompany() {
      if (this.companyName) {
        return this.companyName.length > 0;
      }

      return false;
    },
    hasSelectedCountry() {
      return this.signUpCountry.length > 0;
    },

    showLaserOptimized() {
      if (this.product.categories !== null && this.product.categories.length > 0) {
        const laserCategory = 'cera_laseroptimized';
        const productCategories = this.product.categories.map(item => item.code);

        //should be true
        return productCategories.includes(laserCategory);
      }

      return false;
    }
  },

  methods: {

    async addSelectedVariantToCart() {

      const requestData = {
        product_id: this.product.id,
        variant_id: this.selectedVariant.id,
        quantity: { value: this.quantity }
      }

      const response = await axios.post('/api/proxify/domains/cerakote/shop/cart', requestData)
      const responseData = response.data ?? response;

      this.setPricePerUnit(this.selectedVariant.pricing, this.quantity)

      window.appVariables.bus.$emit('cart-items-added', {
        product: this.product,
        cart: responseData,
        data: requestData,
        multipleItems: false,
        swatchItem: false,
        showBanner: true
      });

      // this is for GA4
      dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: "USD",
          value: parseFloat(this.$root.cart.items_total.amount),
          items: [{
            item_id: this.$root.itemJustAddedToCart.product.sku,
            item_name: this.$root.itemJustAddedToCart.product.name,
            affiliation: this.$root.me.customer_id ? this.$root.me.customer_id : undefined,
            coupon: undefined,
            currency: "USD",
            discount: parseFloat(this.$root.itemJustAddedToCart.product.savings.amount),
            index: undefined,
            item_brand: "Cerakote",
            item_category: this.$root.itemJustAddedToCart.product.pricing[0].starting_quantity.unit,
            item_list_id: undefined,
            item_list_name: undefined,
            item_variant: undefined,
            location_id: "Cart",
            price: parseFloat(this.$root.itemJustAddedToCart.product.pricing[0].price_per_base_quantity.amount),
            quantity: 1
          }]
        }
      });

    },

    async submitAccountInfo() {
      this.loading = true;
      try {
        let accountDataResponse = await this.submitAccountData();
        this.$root.me.primary_phone = accountDataResponse.data.primary_phone;
        this.$root.me.customer_id = accountDataResponse.data.customer_id;
        this.$root.me.primary_email = accountDataResponse.data.primary_email;
        this.$root.me.company_name = accountDataResponse.data.company_name;
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
        this.accountInfoFailed = true;
      }
    },
    submitAccountData() {
      let payload = {};

      if (!this.$root.me.primary_phone) {
        payload["primary_phone"] = this.phoneNumber;
      }

      if (!this.$root.me.customer_id) {
        payload.signup_country_code =
          this.signUpCountry ||
          this.selectedPaymentOption.billing_address.country.code;
      }

      if (!this.$root.me.primary_email) {
        payload.primary_email = this.primaryEmail;
      }

      if (!this.$root.me.company_name) {
        if (this.hasCompany) {
          payload.company_name = this.companyName;
        } else {
          payload.company_name = this.$root.me.name.formatted_name;
        }
      }

      return axios.patch(`/api/proxify/me`, payload);
    },
    addKitToCart() {
      let kit = flexible(_.cloneDeep(this.product));

      if (this.hasPicklist && this.selectedPicklistProduct) {
        const picklistItemIndex = _.findIndex(
          kit.kit_items,
          (item) => item.id === this.selectedPicklistProduct
        );
        kit.kit_items[picklistItemIndex]["selected"] = true;
      }

      if (
        !_.isEmpty(this.kitRule[0]) &&
        this.kitRule[0].amount === this.productCount
      ) {
        const kitRuleIndex = _.findIndex(
          kit.kit_items,
          (item) => item.type === "rule"
        );
        kit.kit_items[kitRuleIndex].shop_product = this.selectedProducts;
      }

      if (
        !_.isEmpty(this.kitRule[1]) &&
        this.kitRule[1].amount === this.productCount_extra
      ) {
        const kitRuleIndex = _.findIndex(
          kit.kit_items,
          (item) => item.type === "rule"
        );
        kit.kit_items[kitRuleIndex].shop_product = this.selectedProducts;
      }

      this.addKitItemsToCart(kit);
    },
    handleProductSelection(product) {
      this.appendedProduct = {};
      const productIndex = _.findIndex(
        this.selectedProducts,
        (item) => item.sku === product.sku
      );

      if (productIndex === -1) {
        product["order_quantity"] = 1;
        this.selectedProducts.push(product);
        this.productCount++;
        this.$forceUpdate();
      } else {
        this.selectedProducts[productIndex].order_quantity++;
        this.productCount++;
        this.$forceUpdate();
      }
    },

    //TODO @handleProductSelectionExtra isn't ideal. This shouldn't be needed if we're dynamically querying the kit data.

    handleProductSelectionExtra(product) {
      this.appendedProduct_extra = {};
      const productIndex = _.findIndex(
        this.selectedProducts,
        (item) => item.sku === product.sku
      );

      if (productIndex === -1) {
        product["order_quantity"] = 1;
        this.selectedProducts.push(product);
        this.productCount_extra++;
        this.$forceUpdate();
      } else {
        // existing product, add quantity for product
        this.selectedProducts[productIndex].order_quantity++;
        this.productCount_extra++;
        this.$forceUpdate();
      }
    },
    resetKitItems() {
      this.productCount = 0;
      this.productCount_extra = 0;
      this.selectedProducts = [];
      this.selectedPicklistProduct = "";
    },
    calculateVariantTotalPrice() {
      let variantPrice = parseFloat(this.selectedVariantPrice);
      this.variantTotalPrice = (variantPrice * this.quantity).toFixed(2);
      this.selectedVariantUnit = this.selectedVariant.pricing[0].starting_quantity.unit;
    },

    async getWishlist() {
      let vm = this;
      let productSku = this.product.sku;
      let wishlistURL = `/api/proxify/me/wishlist?q=${productSku}&domain=cerakote`;

      try {
        let response = await axios.get(wishlistURL);
        if (response.data.data.length) {
          vm.isOnWishlist = true;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async submitQuestion() {
      let vm = this;
      let postMessageUrl = `/api/proxify/domains/cerakote/messages`;

      if (!vm.question.payload.body) {
        vm.question.response.type = "error";
        vm.$refs.notifications.add({
          delay: false,
          type: "error",
          icon: "exclamation-triangle",
          title: "Unable to submit question",
          message: `Could not submit question, question message is required.`,
        });

        vm.dismissNotification();

        return;
      }

      try {
        let response = await axios.post(postMessageUrl, vm.question.payload);
        vm.question.response.type = "success";
        vm.question.response.message =
          "Thank you for your submission, we will get back to you shortly.";
        vm.question.payload.body = "";
        vm.askQuestion = false;

        let product = [];
        product.push(vm.product.id);
        let messageProductUrl = `/api/proxify/domains/cerakote/messages/${response.data.id}/products`;
        await axios.put(messageProductUrl, product);

        vm.$refs.notifications.add({
          delay: false,
          type: "success",
          icon: "check",
          title: "Question submitted",
          message: `Your question was uploaded successfully, but must be
            approved before it is visible.`,
        });

        vm.dismissNotification();
      } catch (error) {
        console.log(error);

        vm.$refs.notifications.add({
          type: "error",
          icon: "exclamation-triangle",
          title: "Unable to submit comment",
        });

        vm.dismissNotification();
      }

      vm.question.response.type = "";
    },

    dismissNotification() {
      setTimeout(() => {
        this.$refs.notifications.notifications = [];
      }, 1000);
    },

    cancelSubmitQuestion() {
      this.question.payload.body = "";
      this.question.response.type = "";
      this.askQuestion = false;
    },

    async addToWishlist(productId) {
      if (!this.isLoggedIn) {
        $("#logInLink").click();
        return;
      }
      let vm = this;
      const url = `/api/proxify/me/wishlist/${productId}`;

      try {
        let response = await axios.put(url, {});
        vm.isOnWishlist = true;
        if (response.data.success) {
          alert("Added successfully");
        }
      } catch (error) {
        alert("Could not add to wishlist");
      }
    },

    async deleteWishlistItem(productId) {
      const url = `/api/proxify/me/wishlist/${productId}`;

      try {
        let response = await axios.delete(url, { data: {} });
        if (response.data.success) {
          this.$refs[`wishlistItem${productId}`].remove();
        }
      } catch (error) {
        alert("Could not remove from wishlist");
      }
    },

    /**
     * @todo Refactor this and make it more VueIsh
     */
    changePrice() {
      if (!this.variants.length) {
        let product = this.product;
        let isNum = /^\d+$/;
        let amountEntered = $("#amountEntered").val();
        if (
          product.sku.substring(0, 3) !== "APP" &&
          product.sku.substring(0, 2) !== "SE" &&
          product.sku.substring(0, 3) !== "1H-" &&
          parseFloat(amountEntered) > product.quantity_available
        ) {
          this.product.stock_level = "out_of_stock";
        } else {
          this.product.stock_level = "in_stock";
        }

        let correctedAmount = amountEntered;
        if (amountEntered % 1 != 0) {
          correctedAmount = Math.trunc(amountEntered);
          $("#amountEntered").val(correctedAmount);
        }
        let total = null;

        if (isNum.test(correctedAmount)) {
          if (product.pricing[0].price_per_base_quantity.unit === "item") {
            let pricePerItem =
              product.pricing[0].price_per_base_quantity.amount;
            total = (correctedAmount * pricePerItem).toFixed(2);

            $("#total")[0].textContent = total;
          } else {
            let pricing = product.pricing;
            let price1 = pricing[0].price_per_base_quantity;
            let price2 = {};
            let priceQuantityMin2 = 0;
            let price3 = {};
            let priceQuantityMin3 = 0;
            if (pricing.length > 1) {
              price2 = pricing[1].price_per_base_quantity;
              priceQuantityMin2 = pricing[1].starting_quantity.value;
            }
            if (pricing.length > 2) {
              price3 = pricing[2].price_per_base_quantity;
              priceQuantityMin3 = pricing[2].starting_quantity.value;
            }

            let calculatedPrice = null;

            if (pricing.length > 2) {
              if (correctedAmount < priceQuantityMin2) {
                total = correctedAmount * price1.amount;
                calculatedPrice = price1.formatted;
              } else if (correctedAmount < priceQuantityMin3) {
                total = correctedAmount * price2.amount;
                calculatedPrice = price2.formatted;
              } else {
                total = correctedAmount * price3.amount;
                calculatedPrice = price3.formatted;
              }
            } else if (pricing.length > 1) {
              if (correctedAmount < priceQuantityMin3) {
                total = correctedAmount * price2.amount;
                calculatedPrice = price2.formatted;
              } else {
                total = correctedAmount * price2.amount;
                calculatedPrice = price2.formatted;
              }
            } else {
              total = correctedAmount * price1.amount;
              calculatedPrice = price1.formatted;
            }

            $("#pricePerUnit")[0].textContent = calculatedPrice;
          }

          $("#total")[0].textContent = parseFloat(total).toFixed(2);
        }
      } else {
        this.calculateVariantTotalPrice();
      }
    },
    printTDSFromBladeTemplate() {
      // calls a Vue child components function.
      this.$refs.callPrintSpecData.printTDS();
    }
  },
});

// displays the add-to-cart dropdown
require("./app_events");
